import React, { useState } from 'react';
import { uploadFile } from '../services/balanceSheetService';

function UploadComponent({ onDataReceived }) {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [validationMsg, setValidationMsg] = useState('');

  const handleFileChange = (e) => {
    setFile(e.target.files[0] || null);
    setError('');
    setValidationMsg('');
  };

  const handleUpload = async () => {
    // Reset messages
    setError('');
    setValidationMsg('');

    // Validate file selection
    if (!file) {
      setValidationMsg('Please select a file');
      return;
    }

    setLoading(true);
    try {
      const response = await uploadFile(file);
      onDataReceived(response.data);
    } catch (err) {
      setError('Failed to upload file');
      onDataReceived(null);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="upload-card mb-4">
      <h5>Upload Excel File</h5>
      <div className="file-input-wrapper">
        <input
          type="file"
          className="form-control"
          accept=".xlsx,.xls"
          onChange={handleFileChange}
          disabled={loading}
          aria-label="Select Excel file"
        />
        <button
          className="btn btn-upload"
          onClick={handleUpload}
          disabled={loading}
        >
          {loading ? 'Uploading...' : 'Upload'}
        </button>
      </div>

      {loading && (
        <div className="status-message loading">
          <span
            className="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
          Uploading, please wait...
        </div>
      )}

      {validationMsg && !loading && (
        <div className="status-message validation" role="alert">
          {validationMsg}
        </div>
      )}

      {error && !loading && (
        <div className="status-message error" role="alert">
          {error}
        </div>
      )}
    </div>
  );
}

export default UploadComponent;
